TPS.OwlCarousel = {
    init: function (selector, numItems, showDots, showNav, responsiveObj) {
        if (selector) {
            var hasChildren = jQuery(selector).children().length > 1;

            if (!responsiveObj) {
                responsiveObj = {};
            }

            if (hasChildren) {
                jQuery(selector).addClass("owl-carousel").owlCarousel({
                    autoHeight: true,
                    autoplay: false,
                    autoplayHoverPause: false,
                    items: numItems,
                    animateOut: 'fadeOut',
                    animateIn: 'fadeIn',
                    center: true,
                    lazyLoadEager: 1,
                    loop: true,
                    dots: showDots ? true : false,
                    nav: showNav ? true : false,
                    navText: [
                        "<span class='icon ion-ios-arrow-left'></span><span class='sr-only'>prev</span>",
                        "<span class='icon ion-ios-arrow-right'></span><span class='sr-only'>next</span>"
                    ],
                    responsive: responsiveObj
                });
            }
        }
    },
    loginFeatures: function(selector, numItems, showDots, showNav, responsiveObj) {

        if (selector) {
            var hasChildren = jQuery(selector).children().length > 1;

            if (!responsiveObj) {
                responsiveObj = {
                    // breakpoint from 0 up
                    0: {
                        stagePadding: 0
                    },
                    // breakpoint from 768 up
                    768: {
                        stagePadding: 115
                    },
                    // breakpoint from 1024 up
                    1024: {
                        stagePadding: 220,
                        autoWidth: true
                    },

                };
            }

            if (hasChildren) {
                var features = jQuery(selector).addClass("owl-carousel").owlCarousel({
                    autoHeight: true,
                    autoplay: false,
                    autoplayHoverPause: false,
                    items: numItems,
                    //animateOut: 'fadeOut',
                    //animateIn: 'fadeIn',
                    center: true,
                    lazyLoadEager: 1,
                    loop: true,
                    dots: showDots ? true : false,
                    nav: showNav ? true : false,
                    navText: [
                        "<span class='icon ion-ios-arrow-left'></span><span class='sr-only'>prev</span>",
                        "<span class='icon ion-ios-arrow-right'></span><span class='sr-only'>next</span>"
                    ],
                    //navContainer: '.login-features-nav',
                    responsive: responsiveObj
                });

            }
        }

    }
}
